<template lang="pug">
   div.chart-tip
       span.tip-label {{ label }}：
       p.tip-content(v-html="content")
</template>

<script>
  
    export default {
        props : {
            label : {
                type : String,
                default : "数据解读"
            },
            content : {
                type : String,
                default : ''
            }
        }
    }
</script>
<style scoped>
.tip-content{
    display: inline-block;
    margin-bottom: 0;
}
.chart-tip{
    margin: 20px;
    background: #f5f8fb;
    line-height: 37px;
    padding-left: 20px;
    color: #596980;
}
</style>



// WEBPACK FOOTER //
// infotip.vue?3eed6edd